import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import Decimal from 'decimal.js';
import { colors } from '../../../utils/colors';
/* eslint-disable react/no-did-update-set-state */

class AvgReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      value: new Decimal(props.value)
        .times(100)
        .toDecimalPlaces(2, Decimal.ROUND_DOWN)
        .toNumber(),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: new Decimal(this.props.value)
          .times(100)
          .toDecimalPlaces(2, Decimal.ROUND_DOWN)
          .toNumber(),
      });
    }
  }

  handleBlur = () =>
    this.setState({
      focused: false,
    });

  focus = () => {
    const { handler, value } = this.props;

    if (!value) {
      handler('');
    }

    return this.setState({ focused: true });
  };

  render() {
    const { focused } = this.state;
    const { handler, ticker } = this.props;

    return !focused ? (
      <div>
        <Value onClick={this.focus}>
          {this.state.value}%{' '}
          <Icon name="edit icon" style={{ color: colors.blue }} />
        </Value>
      </div>
    ) : (
      <Input
        size="mini"
        type="number"
        value={this.state.value}
        onChange={(e) => {
          const targetValue = e.target.value;
          let newValue;
          if (targetValue) {
            newValue = new Decimal(targetValue)
              .toDecimalPlaces(2, Decimal.ROUND_DOWN)
              .toNumber();
          } else {
            newValue = null;
          }
          this.setState({
            value: newValue,
          });
          handler(newValue, ticker);
        }}
        style={{ maxWidth: 80 }}
        onBlur={this.handleBlur}
        autoFocus
      />
    );
  }
}

AvgReturn.propTypes = {
  handler: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ticker: PropTypes.string.isRequired,
};

export default connect()(AvgReturn);

const Value = styled.span`
  position: relative;
  cursor: pointer;
  color: colors.blue;
  padding: 11px 5px;
  text-align: right;

  &:hover {
    text-decoration: underline;
  }
`;
